import {
  faFacebookSquare,
  faLinkedin,
  faGithubSquare,
  faXTwitter,
  faInstagramSquare,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

let SocialData = [
  {
    socialMediaID: 1,
    socialMediaName: "Facebook",
    socialMediaIcon: faFacebookSquare,
    socialMediaLink: "https://www.facebook.com/mithun.awesome/",
  },

  // {
  //   socialMediaID: 2,
  //   socialMediaName: "Linkedin",
  //   socialMediaIcon: faLinkedin,
  //   socialMediaLink: "https://www.linkedin.com/",
  // },

  {
    socialMediaID: 2,
    socialMediaName: "Github",
    socialMediaIcon: faGithubSquare,
    socialMediaLink: "https://github.com/mithunkumar0604",
  },

  {
    socialMediaID: 3,
    socialMediaName: "Twitter",
    socialMediaIcon: faXTwitter,
    socialMediaLink: "https://twitter.com/mithunkumar0604",
  },

  {
    socialMediaID: 4,
    socialMediaName: "Instagram",
    socialMediaIcon: faInstagramSquare,
    socialMediaLink: "https://www.instagram.com/mithu.cookie.monster/",
  },

  {
    socialMediaID: 5,
    socialMediaName: "Email",
    socialMediaIcon: faEnvelope,
    socialMediaLink: "mailto:skarosoft@gmail.com",
  },
];

export default SocialData;
